if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      this.multi = this.form.dataset.multi;
      this.promoP = this.form.dataset.promoproduct;
      this.promoG = this.form.dataset.promogift;

          if (this.multi == 'yes') {
            var multiF = [];
            document.querySelectorAll('.multi-prod-form input:checked').forEach(function(el) {
              var varid = el.dataset.variant;
              multiF.push(varid);
            });

            if (multiF.length > 0) {

            var newVariantIdArray = multiF.toString().split(',');
            var product_data = newVariantIdArray.map(variantId => {
              if (this.promoG != 'no' ) {
                return {quantity: 1, id: variantId, properties: {'_promotion_name': this.promoG}
                }
              } else {
                return {quantity: 1, id: variantId
                }
              }
            })
            var multiData = {
              items: product_data
            }
            if (multiData) {
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
                body: JSON.stringify(multiData)
              })
              .then(response => {
                return response.json();
              }).then((json) => {
              }).catch((error) => {
                console.error('Error:', error);
              });
            }
            };
          }

          var databoughtF = [];
          var opid;
          document.querySelectorAll('.bought-form input:checked').forEach(function(el) {
            var varid = el.dataset.variant;
            var opid = el.dataset.op;
            databoughtF.push(varid);
          });

          if (databoughtF.length > 0) {
            setCookie("_promotion_name", "Bought Together");
            setCookie("_promotion_id", opid);

            var newVariantIdArray = databoughtF.toString().split(',');
            var product_data = newVariantIdArray.map(variantId => {
              return {quantity: 1, id: variantId, properties: {'_promotion_name': 'Bought Together', '_promotion_ID': opid}
              }
            })
            var boughtData = {
              items: product_data
            }
            if (boughtData) {
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
                body: JSON.stringify(boughtData)
              })
              .then(response => {
                return response.json();
              }).then((json) => {
              }).catch((error) => {
                console.error('Error:', error);
              });
            }
          };

      setTimeout(()=> {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        var getpromo = getCookie("promoname");
        if(getpromo){
          if(formData.has("properties[_promotion_name]")) {
          } else {
          formData.append('properties[_promotion_name]', getpromo);
          formData.append('properties[_exclude_discounts]', 'tiers');
          }
        } else if (this.promoP != 'no' ) {
          formData.append('properties[_promotion_name]', this.promoP);
          formData.append('properties[_exclude_discounts]', 'tiers');
        }
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
      },500);
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
  customElements.define('add-to-cart-buttonn', class AddToCartButtonn extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onClickHandler.bind(this));
  }

  onClickHandler(evt) {
    evt.preventDefault();

    if (this.button.getAttribute('aria-disabled') === 'true') return;

    this.button.setAttribute('aria-disabled', true);
    this.button.classList.add('loading');

    const currentBundleVariant = this.button.getAttribute('data-variant');
    const bundleId = this.button.getAttribute('data-bundle-id');
    const bundleStepsHolder = this.button.closest('.bundle_steps_holder');
    const bundleactiveSteps = bundleStepsHolder.querySelectorAll('.bundle_steps_container .bundle__steps.active');
    let minimu_products_to_add = 0;
    let bundle_original_price = this.querySelector('.cuttoff-price').innerHTML;
    if (document.querySelector('.minimum_quantity_allowed') !== null && document.querySelector('.minimum_quantity_allowed') !== undefined) {
      minimu_products_to_add = parseInt(document.querySelector('.minimum_quantity_allowed').value);
    }
    if (bundleactiveSteps.length >= minimu_products_to_add) {
      const selectedProducts = [];
      bundleactiveSteps.forEach(function(step) {
        const prodItem = {
          variantId: step.getAttribute('data-variant-id'),
          quantity: "1",
          category: "Hairtamin",
          type: "product",
          properties: {}
        };
        selectedProducts.push(prodItem);
      });

      const currentDate = Date.now();
      const identifier = `${bundleId}_${currentDate}`;
      const addToCartFormData = { items: [] };

      // Preparing line item properties
      const bundleLineItemProperties = selectedProducts.map(product => ({
        variantId: parseInt(product.variantId),
        quantity: parseInt(product.quantity),
        type: product.type, // 'product' or 'addOns'
        properties: product.properties
      }));

      // Preparing add to cart data
      addToCartFormData.items.push({
        id: currentBundleVariant,
        quantity: 1,
        properties: {
          "__foxsell:dynamic_add_on_bundle_id": identifier,
          "__foxsell:dynamic_add_on_bundle_items": JSON.stringify(bundleLineItemProperties),
          "_bundle_original_price": bundle_original_price
        }
      });
      let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      addToCartFormData.sections = cart.getSectionsToRender().map(section => section.id);
      addToCartFormData.sections_url = window.location.pathname;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(addToCartFormData)
      })
      .then(response => response.json())
      .then(response => {
        console.log('Product added to cart:', response);
        // debugger
        let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart) {
          cart.renderContents(response);
          cart.classList.remove('is-empty')
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        } else {
          window.location = '/cart';
        }
      })
    } else {
      alert(`Please select at least ${minimu_products_to_add} products.`);
      this.button.classList.remove('loading');
      this.button.removeAttribute('aria-disabled');
    }
  }
  });
}
